import { defineQuery } from 'groq';

export const nativeHomepageHeroQuery = defineQuery(`
  *[_type == "nativeHomepageHero"][0]{
    isLtoActive,
    ltoName,
    "videoUrl": video.asset->url,
    poster
  }
`);
